import { LocationVarKey } from "@swivl-mono/types";

import { IS_EQUAL, IS_NOT_EQUAL, IS_TRUE } from "../../../Components/Worksheets/Types/Worksheet.Interface";
import {
  DropdownRow,
  Indent,
  InputRow,
  MultiLineRow,
  PageHeader,
  Section,
  SectionHeader,
  SwitchRow,
  TextAreaRow,
  TextRow
} from "../../../Components/Worksheets/WorksheetComponent/WorksheetComponents";
import { usePropertiesGetLocationIds } from "../../../Hooks/usePropertiesGetLocationIds";

export const PAGE_KEYS: LocationVarKey[] = [
  LocationVarKey.GoogleReviewsAutoReplyEnabled,
  LocationVarKey.GoogleReviewsAutoReplyMinRating,
  LocationVarKey.ReviewReplyGeneral,
  LocationVarKey.ReviewReply5Star,
  LocationVarKey.ReviewReplyPromoter,
  LocationVarKey.ReviewReplyPassive,
  LocationVarKey.ReviewReplyDetractor,
  LocationVarKey.ReviewReply1Star
];

export default function WorksheetView() {
  const page = usePropertiesGetLocationIds();
  return (
    <>
      <PageHeader {...page} subheading="">
        {" "}
        AI Auto-Replies{" "}
      </PageHeader>
      <SwitchRow {...page} keyName={LocationVarKey.GoogleReviewsAutoReplyEnabled} label="Auto-Replies Enabled" />
      <Section {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.GoogleReviewsAutoReplyEnabled, "1")}>
        <InputRow {...page} keyName={LocationVarKey.GoogleReviewsAutoReplyMinRating} label="Rating Threshold" />
        <div className="cortexDescription">Reviews with ratings greater than or equal to this value will be automatically replied to by swivl</div>
        <div className="cortexDescription">
          Default prompt: <i>“Create a reply to this review. We are helpful and friendly.”</i> Email{" "}
          <a href="mailto:support@tryswivl.com" style={{ color: "#FF5B02", textDecoration: "underline" }}>
            support@tryswivl.com
          </a>{" "}
          to update
        </div>
      </Section>
      <SectionHeader {...page} subheading="">
        {" "}
        General Review Reply{" "}
      </SectionHeader>

      <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.ReviewReplyGeneral} />
      <SectionHeader {...page}>5 Star Review Reply</SectionHeader>
      <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.ReviewReply5Star} />
      <SectionHeader {...page}>Promoter Review Reply</SectionHeader>
      <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.ReviewReplyPromoter} />
      <SectionHeader {...page}> Passive Review Reply</SectionHeader>
      <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.ReviewReplyPassive} />
      <SectionHeader {...page}>Detractor Review Reply</SectionHeader>
      <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.ReviewReplyDetractor} />
      <SectionHeader {...page}> 1 Star Review Reply</SectionHeader>
      <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.ReviewReply1Star} />
    </>
  );
}
